module.exports = __webpack_public_path__ + "media/img/cv_creator-07886faf37361d4620d25c9d5b857c38.jpg";